import { useEffect } from "react";
import { usePatchPropertyHouseMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyHouseMutation";
import type { ClientPropertyHouseDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getHouseFormSchema } from "web_myplann/Portfolio/Forms/HouseForm/houseFormSchema";
import { mapPropertyToHouseForm } from "web_myplann/Portfolio/Forms/HouseForm/mapPropertyToHouseForm";
import { useEditPortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useEditPortfolioForm";

type UseEditHouseFormArgs = {
	propertyId: number;
	property: ClientPropertyHouseDetailResponseDTO;
	detailRoute: string;
};

export const useEditHouseForm = ({
	propertyId,
	property,
	detailRoute,
}: UseEditHouseFormArgs) => {
	const { t } = useResource();
	const { mutate, isPending } = usePatchPropertyHouseMutation(propertyId);

	const { form, onSubmit } = useEditPortfolioForm({
		schema: getHouseFormSchema(t),
		defaultValues: mapPropertyToHouseForm(property),
		mutate,
		successToast: t(Resources.Portfolio.EditRealEstate.savedToast, {
			type: t(Resources.Portfolio.AddRealEstate.Types.House),
		}),
		redirectTo: detailRoute,
	});

	useEffect(() => {
		form.trigger();
	}, [form.trigger]);

	return { form, onSubmit, isPending };
};
